import { LOCATION_CHANGE } from 'react-router-redux';

import * as D from '../../deps';
import * as SpecialOffersConstants from '../constants';

import * as Workers from './workers';

export default [
  {
    actionType: SpecialOffersConstants.Actions.ENTER_CODE_REDEMPTION_FLOW,
    handler: Workers.onEnterCodeRedemptionFlow,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Api.ApiActions.ACQUIRE_PRODUCT_ATTEMPT,
    handler: Workers.onAcquireProductAttempt,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.ACQUIRE_PRODUCT_SUCCESS,
    handler: Workers.onAcquireProductSuccess,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.ACQUIRE_PRODUCT_FAIL,
    handler: Workers.onAcquireProductFail,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.LOGOUT_SUCCESS,
    handler: Workers.onLogout,
    concur: 'takeEvery',
  },
  {
    actionType: LOCATION_CHANGE,
    handler: Workers.onLocationChange,
    concur: 'takeEvery',
  },
];
